import {
  Autocomplete,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import SaveIcon from '@mui/icons-material/Save';
import { useState } from 'react';
import { updateItem } from '../../services/Item';
import { useNotify } from 'react-admin';
import { ItemDeleteButton } from './ItemDeleteButton';
import { ItemStatus } from '../../constants/Status';

export const ItemEdit = ({ handleBack, item, handleBackFirstPage }) => {
  const notify = useNotify();

  const initState = {
    itemId: item.id,
    name: item.name,
    description: item.description,
    price: item.price,
    quantity: item.quantity,
    unit: item.unit,
    status: item.status,
    attributes: JSON.stringify({
      image:
        'https://cdn.imgbin.com/2/12/3/imgbin-birthday-cake-torte-fruitcake-chocolate-cake-wedding-cake-chocolate-cake-T3SKpQUE7VFgh4fCRZR0Uk2mP.jpg',
      color: 'blue',
    }),
  };
  const initValidationState = { status: false, message: ' ' };
  const [itemEdit, setItemEdit] = useState(initState);
  const [errorName, setErrorName] = useState(initValidationState);
  const [errorPrice, setErrorPrice] = useState(initValidationState);
  const [errorQuantity, setErrorQuantity] = useState({
    status: false,
    message: ' ',
  });
  const [errorUnit, setErrorUnit] = useState(initValidationState);

  const handleChangeName = (e) => {
    setErrorName(initValidationState);
    setItemEdit((prev) => ({ ...prev, name: e.target.value.trim() }));
  };
  const handleChangeDescription = (e) => {
    setItemEdit((prev) => ({ ...prev, description: e.target.value }));
  };
  const handleChangePrice = (e) => {
    setErrorPrice(initValidationState);
    setItemEdit((prev) => ({ ...prev, price: parseInt(e.target.value) }));
  };
  const handleChangeQuantity = (e) => {
    setErrorQuantity(initValidationState);
    setItemEdit((prev) => ({ ...prev, quantity: parseInt(e.target.value) }));
  };
  const handleChangeUnit = (e) => {
    setErrorUnit(initValidationState);
    setItemEdit((prev) => ({ ...prev, unit: e.target.value.trim() }));
  };
  const handleChangeStatus = (event, value) => {
    setItemEdit((prev) => ({
      ...prev,
      status: value === null ? null : value.id,
    }));
  };

  //validate data create
  const validateName = () => {
    if (itemEdit.name === null || itemEdit.name === '') {
      setErrorName({ status: true, message: 'Please fill in this field' });
      return false;
    }
    return true;
  };
  const validatePrice = () => {
    if (
      itemEdit.price === null ||
      itemEdit.price < 0 ||
      isNaN(itemEdit.price) ||
      itemEdit.price > 2147483648
    ) {
      setErrorPrice({ status: true, message: 'Invalid price' });
      return false;
    }
    return true;
  };
  const validateQuantity = () => {
    if (
      itemEdit.quantity === null ||
      itemEdit.quantity < 0 ||
      isNaN(itemEdit.quantity) ||
      itemEdit.quantity > 2147483648
    ) {
      setErrorQuantity({ status: true, message: 'Invalid quantity' });
      return false;
    }
    return true;
  };
  const validateUnit = () => {
    if (itemEdit.unit === null || itemEdit.unit === '') {
      setErrorUnit({ status: true, message: 'Please fill in this field' });
      return false;
    }
    return true;
  };

  const handleSave = () => {
    if (
      validateName() &&
      validatePrice() &&
      validateQuantity() &&
      validateUnit()
    ) {
      updateItem(itemEdit)
        .then((res) => {
          notify('Update item successfully!', { type: 'success' });
          handleBack();
        })
        .catch((err) => {
          const error = err.response.errors[0];
          notify(error.message, { type: 'error' });
        });
    } else {
      validateName();
      validatePrice();
      validateQuantity();
      validateUnit();
    }
  };
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          mb: 1,
        }}
      >
        <Button
          endIcon={<DescriptionIcon />}
          sx={{ textAlign: 'left', ml: 1, cursor: 'default' }}
          size="medium"
        >
          <Typography variant="h4">Edit Item</Typography>
        </Button>
        <ItemDeleteButton
          itemId={itemEdit.itemId}
          handleChangeComponent={handleBackFirstPage}
        />
      </Grid>
      <Divider sx={{ width: '100%' }} />
      <Grid
        item
        container
        xs={12}
        spacing={2}
        sx={{
          mt: 1,
          px: 6,
          justifyContent: 'center',
          alignItems: 'center',
          pb: 3,
        }}
      >
        <Grid item xs={12} md={5}>
          <TextField
            defaultValue={item.name}
            label="Name"
            required
            onChange={(e) => handleChangeName(e)}
            error={errorName.status}
            helperText={errorName.message}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            defaultValue={item.description}
            label="Description"
            onChange={(e) => handleChangeDescription(e)}
            helperText=" "
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            defaultValue={item.price}
            required
            label="Price"
            onChange={(e) => handleChangePrice(e)}
            error={errorPrice.status}
            helperText={errorPrice.message}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            defaultValue={item.quantity}
            required
            label="Quantity"
            onChange={(e) => handleChangeQuantity(e)}
            error={errorQuantity.status}
            helperText={errorQuantity.message}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            defaultValue={item.unit}
            required
            label="Unit"
            onChange={(e) => handleChangeUnit(e)}
            error={errorUnit.status}
            helperText={errorUnit.message}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <Autocomplete
            id="auto-complete-status-item"
            options={ItemStatus}
            disableClearable
            value={
              itemEdit.status === null
                ? null
                : {
                  id: itemEdit.status,
                  name: ItemStatus.find(({ id }) => id === itemEdit.status)
                    .name,
                }
            }
            renderInput={(status) => (
              <TextField {...status} required label="Status" helperText=" " />
            )}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.name === value.name}
            onChange={(event, value) => handleChangeStatus(event, value)}
          />
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: 2,
          backgroundColor: '#f5f5f5',
          padding: 1.5,
          borderRadius: 3,
        }}
      >
        <Button
          startIcon={<KeyboardBackspaceIcon />}
          onClick={handleBack}
          variant="outlined"
        >
          Back
        </Button>
        <Button
          disabled={JSON.stringify(initState) === JSON.stringify(itemEdit)}
          startIcon={<SaveIcon />}
          variant="contained"
          onClick={handleSave}
        >
          Save
        </Button>
      </Grid>
    </Grid>
  );
};
